import { useSnackbar } from '@/context/Snackbar';

// The "setTimeout" of zero here is necessary to prevent a permissions issue in safari
// clipboard access can only occur in events so this gets around that limitation
// https://stackoverflow.com/questions/62327358/javascript-clipboard-api-safari-ios-notallowederror-message
const copy = async (value: string): Promise<void> => {
  if (navigator.clipboard && navigator.clipboard.write) {
    // Use modern ClipboardItem API for better Safari compatibility
    const blob = new Blob([value], { type: 'text/plain' });
    const item = new ClipboardItem({ 'text/plain': blob });
    setTimeout(async () => {
      await navigator.clipboard.write([item]);
    }, 0);
  } else {
    // Fallback to writeText for browsers that support it but not ClipboardItem
    setTimeout(async () => {
      await navigator.clipboard.writeText(value);
    }, 0);
  }
};

export const useCopyToClipboard = () => {
  const { infoSnackbar, errorSnackbar } = useSnackbar();

  const copyToClipboard = async (value: string, message?: string) => {
    try {
      await copy(value);
      infoSnackbar(message ?? 'Copied');
    } catch (e) {
      errorSnackbar('Copy to clipboard failed');
    }
  };

  return copyToClipboard;
};
